import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { TLCondensed } from '../components/TLCondensed';

export const TLCondensedProvider = ({ store, data }) => (
    <Provider store={store}>
        <TLCondensed {...data} />
    </Provider>
);

TLCondensedProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
